import {
  AssetCommentAnnotationArrowModel,
  AssetCommentAnnotationDto,
  AssetCommentAnnotationLineModel,
  AssetCommentAnnotationOvalModel,
  AssetCommentAnnotationPolygonModel,
  AssetCommentAnnotationRectModel,
} from '@nusign/picflow-backend-types';
import { AnnotationColorToHex } from '../gallery-shared/types/annotation-color';
import { OtherShape, PolygonShape, Shape } from '../gallery-shared/types/shapes';

const convertShapeToRect = (shape: OtherShape): AssetCommentAnnotationRectModel => {
  return {
    color: AnnotationColorToHex(shape.color),
    tool: 'rect',
    radius: 1, // setting radius to 1 to differentiate "old" and "new" shapes. In the past, we used to use the tool name "rect" for circles... (they used radius: 0)
    size: 0,
    x1: shape.x1,
    y1: shape.y1,
    x2: shape.x2,
    y2: shape.y2,
    h: 0,
    w: 0,
    x: 0,
    y: 0,
  };
};

const convertShapeToOval = (shape: OtherShape): AssetCommentAnnotationOvalModel => {
  return {
    color: AnnotationColorToHex(shape.color),
    tool: 'oval',
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0,
    radius: 1, // setting radius to 1 to differentiate "old" and "new" shapes. In the past, we used to use the tool name "rect" for circles... (they used radius: 0)
    size: 0,
    x: shape.x1,
    y: shape.y1,
    w: shape.x2,
    h: shape.y2,
  };
};

const convertShapeToLine = (shape: OtherShape): AssetCommentAnnotationLineModel => {
  return {
    color: AnnotationColorToHex(shape.color),
    tool: 'line',
    x1: shape.x1,
    x2: shape.x2,
    y1: shape.y1,
    y2: shape.y2,
  };
};

const convertShapeToPolygon = (shape: PolygonShape): AssetCommentAnnotationPolygonModel => {
  return {
    color: AnnotationColorToHex(shape.color),
    tool: 'polygon',
    points: shape.points,
  };
};
const convertShapeToArrow = (shape: OtherShape): AssetCommentAnnotationArrowModel => {
  return {
    color: AnnotationColorToHex(shape.color),
    tool: 'arrow',
    x1: shape.x1,
    x2: shape.x2,
    y1: shape.y1,
    y2: shape.y2,
  };
};

export const convertShapesToAnnotation = (shapes: Shape[]): AssetCommentAnnotationDto[] => {
  if (!shapes) return;
  if (!shapes.length) return;
  return shapes.map(shape => {
    if (shape.tool === 'rect') {
      return convertShapeToRect(shape);
    }
    if (shape.tool === 'oval') {
      return convertShapeToOval(shape);
    }
    if (shape.tool === 'line') {
      return convertShapeToLine(shape);
    }
    if (shape.tool === 'polygon') {
      return convertShapeToPolygon(shape);
    }
    if (shape.tool === 'arrow') {
      return convertShapeToArrow(shape);
    }
  });
};
